import script from "./BillingEditJa.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingEditJa.vue?vue&type=script&setup=true&lang=js"

import "./BillingEditJa.vue?vue&type=style&index=0&id=65aedcae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65aedcae"]])

export default __exports__